import { render } from "./Auth.vue?vue&type=template&id=c48ba9d8&ts=true"
import script from "./scripts/auth.ts?vue&type=script&lang=ts"
export * from "./scripts/auth.ts?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__